import { Model } from 'backbone';
import pageCollection 	from 'PageCollection.js'
import formModel 		from 'formModel.js'

class ReportModel extends Model {

    initialize() {
        pageCollection.add(this); 
        formModel.set({
            currentPage: this.id
        });

        this.initDevice = {
            isHidden: this.get('isHidden')
        };

        this.initDeviceTablet = {
            isHidden: this.get('isHidden')
        };

        this.initDevicePhone = {
            isHidden: this.get('isHidden')
        };

        this.set({
            deviceDesktop: this.initDevice,
            deviceTablet: this.initDeviceTablet,
            devicePhone: this.initDevicePhone
        });

        this.on('change:isHidden', function(){
            this.set( { [formModel.get('currentDevice')]: { isHidden: this.get('isHidden') }});
        });

        var control = this;
        formModel.on('change:currentDevice', function(){

            // hitting attributes directly instead of using getter to
            // access dynamic currentDevice value
            control.set( control.attributes[this.attributes.currentDevice] , {silent: true} );
        });

        // console.log(pageCollection);
    }

    defaults() {
        return {};
    }

}

export default ReportModel;

